import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { ScheduleState } from './schedule.state';

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'schedule', resettable: true, idKey: '_id'})
export class ScheduleStore extends EntityStore<ScheduleState> {
  constructor() {
    super() ;
  }
}
